<template>
  <base-dialog :show-close="true" :visible.sync="visible" class="full-chart-dialog">
    <template v-slot:header>
      <div class="chart-header" :key="figure.chartId">
        <div class="name">
          {{ figure.name }}
        </div>
        <div class="operation">
          <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
            <svg-icon
              class="refresh"
              :class="active ? 'button-active' : ''"
              icon-class="refresh"
              @click.native="refreshChart"
            ></svg-icon>
          </el-tooltip>
          <dropdown-menu
            v-if="exportOptions.length"
            :menu-list="exportOptions"
            @click="handleCommand"
            placement="bottom-end"
          >
            <span class="pointer">
              <svg-icon icon-class="board_more" class="pointer"></svg-icon>
            </span>
          </dropdown-menu>
        </div>
      </div>
    </template>
    <div class="chart-wrapper" :key="figure.chartId">
      <full-board-title
        :figure="figure"
        :filter-visible="filterVisible"
        @setFilter="setFilter"
      ></full-board-title>
      <chart-item
        :chart="figure"
        :boardId="board.id"
        :theme="board.theme"
        :app-id="board.appId"
        hideHeader
        ref="image"
        class="image"
        id="image"
        :data-id="dataId"
        :class="'board-theme-' + board.theme"
      ></chart-item>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import ChartItem from "@/views/Backend/Admin/Statistics/chartEdit/ChartItem"
import FullMixin from "@/views/Backend/Admin/Statistics/FullMixin"
import FullBoardTitle from "@/views/Backend/Admin/Statistics/FullBoardTitle"

export default {
  name: "FullChartDialog",
  components: {
    FullBoardTitle,
    ChartItem,
    BaseDialog,
    DropdownMenu
  },
  props: {
    dataId: String,
    filterVisible: Boolean
  },
  mixins: [FullMixin],
  data() {
    return {
      visible: false,
      board: {},
      figure: {},
      active: false
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.$refs.image?.resize()
      })()
    }
  },
  watch: {
    "figure.type": function() {
      this.$nextTick(() => this.$refs.image.init(this.figure))
    }
  },
  methods: {
    open(board, chart) {
      this.board = board
      this.figure = chart
      this.visible = true
      this.$nextTick(() => this.$refs.image.init(this.figure))
    },
    refreshChart() {
      this.active = true
      setTimeout(() => {
        this.active = false
      }, 1000)
      this.refreshBoard()
    },
    setFilter() {
      this.$emit("setFilter")
    }
  }
}
</script>

<style lang="scss" scoped>
.full-chart-dialog {
  .chart-header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-right: 10px;
    .operation {
      .refresh {
        cursor: pointer;
        margin-right: 6px;
        font-size: 16px;
      }
      .button-active {
        animation: rotate 1s infinite;
        -webkit-animation: rotate 1s infinite;
      }
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
          -ms-transform: rotate(0deg); /* IE 9 */
          -moz-transform: rotate(0deg); /* Firefox */
          -o-transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
          -ms-transform: rotate(360deg); /* IE 9 */
          -moz-transform: rotate(360deg); /* Firefox */
          -o-transform: rotate(360deg);
        }
      }

      @-webkit-keyframes rotate {
        0% {
          -moz-transform: rotate(0deg);
        }
        100% {
          -moz-transform: rotate(360deg);
        }
      }
    }
  }

  .chart-wrapper {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    .full-board-title {
      margin-top: 0;
    }
    .image {
      padding-top: 20px;
      flex: 1;
      position: relative;
    }
  }

  ::v-deep {
    .el-dialog {
      width: 100vw !important;
      height: 100vh;
      max-height: unset;
      .el-dialog__body {
        padding: 0;
        height: 100%;
      }
    }
  }
}
</style>
